// Playlist de videos en menú móvil con reproducción continua
document.addEventListener('DOMContentLoaded', function() {
  const menuDrawer = document.querySelector('.menu-drawer');
  const detailsMenu = document.querySelector('#Details-menu-drawer-container');
  
  // PLAYLIST DE VIDEOS - Agrega todas las URLs que quieras
  const videoPlaylist = [
    'https://cdn.shopify.com/videos/c/o/v/e706db27ba764281bb22f544d4500517.mp4',
    'https://cdn.shopify.com/videos/c/o/v/c6a54ca0b17a4937958e1aa6d780d0f8.mp4',
    'https://cdn.shopify.com/videos/c/o/v/379bdb7791d9425ab95e4c244dcef4bf.mp4',
    'https://cdn.shopify.com/videos/c/o/v/b2ac9089477b446097381b21fe0d64a7.mp4',
    'https://cdn.shopify.com/videos/c/o/v/ab3061f6c65c47a7b12b8f6c5ee68585.mp4',
    'https://cdn.shopify.com/videos/c/o/v/78e170b2184a43e084ed0cbfa444b221.mp4',
    'https://cdn.shopify.com/videos/c/o/v/82500705c87a4500b4cc1646daa69450.mp4',
    'https://cdn.shopify.com/videos/c/o/v/526e9e784ce340339fcda26a30a325c1.mp4',
    'https://cdn.shopify.com/videos/c/o/v/328665184e024328bea33cdabce31481.mp4',
    'https://cdn.shopify.com/videos/c/o/v/04074ddda2974325b1cfb1cc911f2158.mp4',
    'https://cdn.shopify.com/videos/c/o/v/1a3b899c8a4e401ebe27629fde7ee2a9.mp4',
    'https://cdn.shopify.com/videos/c/o/v/f67373fd17a74a5ab307097d5f759486.mp4',
    'https://cdn.shopify.com/videos/c/o/v/c7bd3d455bdf4df881e66be9348b71ff.mp4',
  ];
  
  let currentVideoIndex = Math.floor(Math.random() * videoPlaylist.length); // Aleatorio al cargar página
  let videoCreated = false;
  let video;
  
  if (menuDrawer && detailsMenu) {
    // Crear el video una sola vez
    video = document.createElement('video');
    video.setAttribute('autoplay', '');
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.muted = true;
    video.volume = 0;
    video.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      object-fit: cover;
      z-index: 0;
    `;
    
    // Función para cargar video
    function loadVideo(index) {
      video.innerHTML = '';
      const source = document.createElement('source');
      source.src = videoPlaylist[index];
      source.type = 'video/mp4';
      video.appendChild(source);
      video.load();
      video.play().catch(e => console.log('Video autoplay prevented'));
    }
    
    // Cuando termina un video, cargar el siguiente secuencialmente
    video.addEventListener('ended', function() {
      currentVideoIndex++;
      if (currentVideoIndex >= videoPlaylist.length) {
        currentVideoIndex = 0;
      }
      loadVideo(currentVideoIndex);
    });
    
    // Insertar el video cuando se abre el menú
    detailsMenu.addEventListener('toggle', function() {
      if (detailsMenu.open) {
        if (!videoCreated) {
          // Primera vez: insertar y cargar video aleatorio
          menuDrawer.insertBefore(video, menuDrawer.firstChild);
          loadVideo(currentVideoIndex);
          videoCreated = true;
        }
        // El video ya está reproduciéndose, solo se hace visible
        // No se pausa ni reinicia, continúa desde donde estaba
      }
      // IMPORTANTE: NO pausar cuando cierra el menú
      // El video sigue reproduciéndose en background
    });
  }
});
